import React, { useMemo } from 'react';
import { ApolloProvider, ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { Box } from '@material-ui/core';
import { ToastContainer } from 'react-toastify';
import AdminLogin from 'components/admin/AdminLogin';
import envs from 'config/envs';
import 'react-toastify/dist/ReactToastify.css';

// In development, talk directly to the local backend (e.g. http://localhost:4001/graphql)
// In production, use the configured API base URL
const graphqlUri =
  process.env.NODE_ENV === 'development'
    ? (process.env.REACT_APP_GRAPHQL_URL ||
       process.env.REACT_APP_GRAPHQL_ENDPOINT ||
       (envs.apiBaseUrl || '') + '/graphql' ||
       'http://localhost:4000/graphql')
    : (envs.apiBaseUrl || '') + '/graphql';

/**
 * Standalone login page for admin app. Uses its own Apollo client (no auth header)
 * so the login mutation can run without a token. Used when user hits /login directly
 * or is redirected from /unauthenticated on localhost or admin domain.
 */
const LoginPage: React.FC = () => {
  const client = useMemo(
    () =>
      new ApolloClient({
        link: createHttpLink({ uri: graphqlUri }),
        cache: new InMemoryCache(),
        defaultOptions: {
          mutate: { errorPolicy: 'all' },
        },
      }),
    []
  );

  return (
    <ApolloProvider client={client}>
      <ToastContainer position="top-right" autoClose={3000} />
      <Box
        minHeight="100vh"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        bgcolor="#02172a"
        p={2}
      >
        {process.env.NODE_ENV === 'development' && (
          <Box color="#6b8ea3" fontSize="0.75rem" mb={1} title="Restart admin app after changing .env.local">
            API: {graphqlUri || '(not set)'}
          </Box>
        )}
        <AdminLogin />
      </Box>
    </ApolloProvider>
  );
};

export default LoginPage;
